(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.DownloadService = (function(superClass) {
    extend(DownloadService, superClass);

    function DownloadService(http, window, modal) {
      this.http = http;
      this.window = window;
      this.modal = modal;
      this.showDisclaimer = bind(this.showDisclaimer, this);
      this.checkDisclaimer = bind(this.checkDisclaimer, this);
      this.downloadFile = bind(this.downloadFile, this);
      void 0;
    }

    DownloadService.prototype.downloadFile = function(layer_id, type) {
      this.layer_id = layer_id;
      switch (type) {
        case 'shapefile':
          this.url = "backend/grower/layers/prescription-map/download-shp?id=" + this.layer_id;
          break;
        case 'rxmap':
          this.url = "backend/grower/layers/planting-rx/download?id=" + this.layer_id;
          break;
        case 'rxmap_proprietary':
          this.url = "backend/grower/layers/planting-rx/download-proprietary?id=" + this.layer_id;
          break;
        case 'controller':
          this.url = "backend/grower/layers/prescription-map/download-controller?id=" + this.layer_id;
      }
      return this.checkDisclaimer();
    };

    DownloadService.prototype.checkDisclaimer = function() {
      return this.http.post('backend/grower/rx-warning/disclaimer-info', {
        layer_id: this.layer_id
      }).then((function(_this) {
        return function(response) {
          var info, ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            info = response.data.data;
            return _this.showDisclaimer(info);
          } else {
            return _this.window.open(_this.url, 'blank');
          }
        };
      })(this));
    };

    DownloadService.prototype.showDisclaimer = function(info) {
      var dialog;
      dialog = this.modal.open({
        windowClass: 'small_dialog',
        template: ((function(_this) {
          return function() {
            return _this.http.post('backend/grower/rx-warning/show-disclaimer', {
              info: info
            }).then(function(response) {
              return response.data;
            });
          };
        })(this))(),
        controller: 'Data.Controllers.RxWarningController'
      });
      return dialog.result.then((function(_this) {
        return function() {
          return _this.window.open(_this.url, '_blank');
        };
      })(this));
    };

    return DownloadService;

  })(Service);

}).call(this);
